var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopSecret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3094 4.27714c0-1.07806-.8483-1.96171-1.87331-1.96171-1.04271 0-1.87335.88365-1.87335 1.96171 0 .67157.31812 1.25478.81296 1.60825l-.6539 3.85272c0 .01767.77762.01767 1.73196.01767s1.73194 0 1.73194-.01767l-.6185-3.88807c.4241-.35346.7422-.919.7422-1.5729Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.45371.954345c.2651 0 .47717-.212077.47717-.477173C9.93088.212077 9.71881 0 9.45371 0c-.26509 0-.47717.212077-.47717.477172 0 .265096.21208.477173.47717.477173Zm0 10.091355c-.26509 0-.47717.212-.47717.4771S9.18862 12 9.45371 12c.2651 0 .47717-.2121.47717-.4772s-.21207-.4771-.47717-.4771ZM8.23422 1.09573c-2.35052.38881-4.1355 2.43888-4.1355 4.89544 0 2.47422 1.80265 4.52433 4.17084 4.89543l-.1944 1.025c-2.01473-.3181-3.69367-1.6612-4.50663-3.46388L2.5435 9.47276c-.17673.1944-.47718.1944-.67158 0-.1944-.17673-.1944-.47718 0-.67158l1.36082-1.3785c-.06677-.23372-.10201-.49898-.1355-.75109-.00196-.01478-.00392-.02951-.00588-.04419H1.37707c-.26509 0-.477168-.21208-.477168-.47718 0-.26509.212078-.47717.477168-.47717h1.69662c.01767-.33579.05302-.6539.12371-.95434L1.92494 3.44625c-.1944-.17673-.1944-.47718 0-.67158.17673-.1944.47717-.1944.67158 0l.91899.90133C4.29313 1.82033 5.98974.424156 8.03981.0706953L8.23422 1.09573Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSecret);
export default __webpack_public_path__ + "static/media/top_secret.bf9a682e644563520b0332a85365155d.svg";
export { ForwardRef as ReactComponent };